import CONSTANT from "../constants/Constant";
import { toast } from "react-toastify";
import routes from "../constants/Routes";
import Payment from "../services/Payment";
import DirectToConsumerService from "../services/DirectToConsumerService";
import { setOpenChatBot } from "../features/chat/chatbotSlice";
import { getRedirectType, isMobileDevice } from "../utils/Utils";
import { useContext, useState } from "react";
import GLOBAL from "../global";
import { useDispatch } from "react-redux";
import { useTenantFeatures } from "../features/tenantFeatures/useTenantFeature";
import usePaymentStatusPopup from "../components/shared/Popups/paymentStatusPopup/usePaymentStatusPopup";
import useDeviceCompatibility from "./useDeviceCompatibility";
import { PAYMENT_STATUS_POPUP } from "../features/paymentStatusPopup/paymentStatusPopupConstant";
import AppContext from "../contexts/AppContext";
import { useHistory, useLocation } from "react-router-dom";
// import { redirectTo } from "../components/shared/chatbotNew/ChatServices";
import useChatbot from "../components/shared/chatbotNew/hooks/useChatbot";
import useSweetAlert from "../components/shared/Popups/sweetAlertComponent/useSweetAlert";
import examService from "../services/ExamService";
import { useContext as useAppContext } from "react";
import { useDispatch as useReduxDispatch } from "react-redux";
import {
    setSelectedTelemedicineInvitationId,
    setOpenBiometricMovementAndCautionQuestionContainer,
} from "../features/dashboard/dashboardSlice";
import { _getInCompleteAssessmentType, getResumeGroupFromId } from "../components/dashboard/dashboardUtills";
import { isEmptyObject } from "../utils/Utils";
import { fetchPurchasePackageThunks } from "../features/purchasePackage/purchasePackageThunks";

const useHandlePayment = (openBiometricCautionQuestionModalCallback) => {
    const dispatch = useDispatch();
    const { userInfo, setTelemedicineProperties, resetTelemedicineKeys, setSelectedTabForEditAssessment } = useContext(AppContext);
    const location = useLocation();
    const { showPaymentStatusPopup, hidePaymentStatusPopup, setConfirmBtnLoading, setCancelBtnLoading } = usePaymentStatusPopup();
    const { startChatBot } = useChatbot();
    const history = useHistory();
    const { showSweetAlert, hideSweetAlert } = useSweetAlert();

    // State for assessment purchase modal
    const [showAssessmentPurchaseModal, setShowAssessmentPurchaseModal] = useState(false);
    const [invitationRequestResponse, setInvitationRequestResponse] = useState(null);

    // State for mobile app suggestion modal
    const [showMobileAppSuggestion, setShowMobileAppSuggestion] = useState(false);
    const [pendingAction, setPendingAction] = useState(null);

    const { isAthleteEnabled } = useTenantFeatures();
    const { isMobileAppSuggestionModalEnabled } = useDeviceCompatibility();

    const patientFullName = userInfo?.FullName || ''

    const onOpenTelemedicineModal = () => {
        // Implementation for opening telemedicine modal
    };

    const onCloseTelemedicineModal = () => {
        resetTelemedicineKeys();
        dispatch(setSelectedTelemedicineInvitationId(null));
    };

    const onConfirmNewAssessment = async () => {
        let response = await DirectToConsumerService.invitationRequest({ OrderId: invitationRequestResponse?.OrderId });
        if (response.success) {
            const data = response?.data;
            if (data && data?.InvitationId && data?.InvitationTypeId && data?.BodyRegionIds && data?.MeetingStartDate && data?.MeetingEndDate) {
                const bodyRegionList = data?.BodyRegionIds.split(',').map(Number).filter(Boolean) || []

                startChatBot(
                    {
                        InvitationId: data?.InvitationId,
                        BodyRegionList: bodyRegionList,
                        InvitationTypeName: getRedirectType(data?.InvitationTypeId),
                    },
                    GLOBAL?.USER_INFO?.ContactId || '', //patientId
                    data?.MeetingEndDate || '', //meetingStart
                    data?.MeetingStartDate || '', //meetingEnd
                    () => {
                        // Emit event to reload my-assessments table if on my-assessments page
                        if (location.pathname.includes(routes.myAssessments)) {
                            const refreshEvent = new CustomEvent('refreshMyAssessmentsTable');
                            window.dispatchEvent(refreshEvent);
                        } else {
                            window.location.reload()
                        }

                        // Callback after chatbot starts
                        setShowAssessmentPurchaseModal(false);
                    }
                )
            }
            setShowAssessmentPurchaseModal(false);
        } else {
            toast.error("Failed to start assessment, please try again later");
        }
    };

    const onCancelFollowUpAssessment = async () => {
        if (!invitationRequestResponse) return;

        let invitationRequestApiResponse = await DirectToConsumerService.invitationRequest({ OrderId: invitationRequestResponse?.OrderId });
        if (invitationRequestApiResponse.success) {
            const invitationRequestResponse = invitationRequestApiResponse?.data;
            const response = await examService.followUp({
                InvitationId: invitationRequestResponse.InvitationId,
                BaseTestId: invitationRequestResponse.BaseTestId,
                StartTime: invitationRequestResponse.MeetingStartDate,
                EndTime: invitationRequestResponse.MeetingEndDate,
                TimeZone: invitationRequestResponse.TimeZone
            });
            const { data, success, error } = response;

            if (success) {
                dispatch(fetchPurchasePackageThunks());

                // Emit event to reload my-assessments table if on my-assessments page
                if (location.pathname.includes(routes.myAssessments)) {
                    const refreshEvent = new CustomEvent('refreshMyAssessmentsTable');
                    window.dispatchEvent(refreshEvent);
                }

                setShowAssessmentPurchaseModal(false);
                showSweetAlert({
                    title: 'Update Your Information?',
                    message: 'Would you like to update your background information (Activities of Daily Living, Medical History, Chief Complaints)?',
                    type: CONSTANT.ALERT_TYPE.INFO,
                    onConfirm: () => {
                        hideSweetAlert();
                        if (+invitationRequestResponse?.InvitationTypeId === CONSTANT.INVITATION_TYPE.Telemedicine) {
                            setTelemedicineProperties(invitationRequestResponse.InvitationId, invitationRequestResponse.BodyRegionList, onOpenTelemedicineModal, onCloseTelemedicineModal);
                            dispatch(setSelectedTelemedicineInvitationId(invitationRequestResponse.InvitationId));
                        } else if (+invitationRequestResponse?.InvitationTypeId === CONSTANT.INVITATION_TYPE.Self) {
                            openBiometricCautionQuestionModal({
                                ...invitationRequestResponse,
                                TestId: data.TestId
                            });
                        } else {
                            // Do nothing
                        }
                    },
                    onClose: () => {
                        hideSweetAlert();
                    },
                    showCloseBtn: true,
                    onCancel: () => {
                        hideSweetAlert();
                        redirectToEditAssessmentPage({ ...invitationRequestResponse, TestId: data.TestId });
                    },
                    showCancelBtn: true,
                    showConfirmBtn: +invitationRequestResponse?.InvitationTypeId !== CONSTANT.INVITATION_TYPE.InClinic,
                    showOkBtn: false,
                    confirmBtnText: +invitationRequestResponse?.InvitationTypeId !== CONSTANT.INVITATION_TYPE.InClinic ? 'Resume Assessment' : '',
                    cancelBtnText: 'Update My Background',
                });
            }
        } else {
            toast.error("Failed to start assessment, please try again later");
        }
    };

    const toggleAssessmentPurchaseModal = () => {
        setShowAssessmentPurchaseModal(false);
    };

    const openBiometricCautionQuestionModal = (invitationData) => {
        if (openBiometricCautionQuestionModalCallback) {
            // Use callback if provided (for my-assessments page)
            openBiometricCautionQuestionModalCallback({
                testId: invitationData.TestId,
                bodyRegionList: invitationData.BodyRegionList
            });
        } else if (location.pathname.includes(routes.myAssessments)) {
            // If we're on my-assessments page but no callback provided, 
            // we need to emit a custom event that the page can listen to
            const event = new CustomEvent('openBiometricModal', {
                detail: {
                    testId: invitationData.TestId,
                    bodyRegionList: invitationData.BodyRegionList
                }
            });
            window.dispatchEvent(event);
        } else {
            // Default behavior (for dashboard page)
            dispatch(setOpenBiometricMovementAndCautionQuestionContainer({
                openBiometricMovementAndCautionQuestionContainer: true,
                testId: invitationData.TestId,
                selectedBodyRegions: invitationData.BodyRegionList
            }));
        }
    };

    const redirectToEditAssessmentPage = (invitationData) => {
        let firstInCompletedGroup = getResumeGroupFromId(invitationData?.ResumeGroupId);
        let keyOfFirstIncompleteGroup = CONSTANT.ASSESSMENT_GROUP.DEMOGRAPHICS.key;
        if (!isEmptyObject(firstInCompletedGroup)) {
            keyOfFirstIncompleteGroup = firstInCompletedGroup?.key || CONSTANT.ASSESSMENT_GROUP.DEMOGRAPHICS.key;
            if (keyOfFirstIncompleteGroup === CONSTANT.ASSESSMENT_GROUP.BIOMETRIC.key) keyOfFirstIncompleteGroup = CONSTANT.ASSESSMENT_GROUP.DEMOGRAPHICS.key
        }
        setSelectedTabForEditAssessment(keyOfFirstIncompleteGroup);
        history.push(`${routes.editAssessment}/${invitationData.TestId}?groupId=${getResumeGroupFromId(invitationData?.ResumeGroupId)?.key}`);
    };

    const handleOrderPlace = () => {
        const search = location?.search || '';
        const queryString = search.includes('?') ? search.split('?')[1] : '';
        const query = new URLSearchParams(queryString);
        let success = query.get(CONSTANT.QUERY_PARAM.SUCCESS) || '';
        let orderId = query.get(CONSTANT.QUERY_PARAM.ORDER_ID) || '';
        let packageId = query.get(CONSTANT.QUERY_PARAM.PACKAGE_ID) || '';
        let bodyRegionIdsFromUrl = query.get(CONSTANT.QUERY_PARAM.BODY_REGION_IDS) || '';
        let assessmentNameFromUrl = query.get(CONSTANT.QUERY_PARAM.ASSESSMENT_NAME) || '';

        let bodyRegionList = bodyRegionIdsFromUrl.split(',').map(Number).filter(Boolean) || [];
        if (success.toLowerCase() === 'true' && orderId) {
            showPaymentStatusPopup(
                PAYMENT_STATUS_POPUP.SUCCESS,
                () => {
                    const action = () => {
                        handleOnClickStartNow(orderId, bodyRegionList)
                        history.push(`${routes.myAssessments}/false`, { refresh: true });
                    };

                    if (isMobileAppSuggestionModalEnabled && isMobileDevice()) {
                        // User is on mobile device - show mobile app suggestion modal
                        setPendingAction(() => action);
                        setShowMobileAppSuggestion(true);
                    } else if (isMobileAppSuggestionModalEnabled && !isMobileDevice()) {
                        // User is on desktop/laptop - show mobile app suggestion modal with pending action
                        setPendingAction(() => action);
                        setShowMobileAppSuggestion(true);
                    } else {
                        action();
                    }
                },
                () => {
                    const action = () => {
                        handleOnClickStartLater(orderId)
                        history.push(`${routes.myAssessments}/false`, { refresh: true });
                    };

                    if (isMobileAppSuggestionModalEnabled && isMobileDevice()) {
                        setPendingAction(() => action);
                        setShowMobileAppSuggestion(true);
                    } else {
                        action();
                    }
                }
            );
        } else if (success.toLowerCase() === 'false' && orderId) {
            showPaymentStatusPopup(
                PAYMENT_STATUS_POPUP.FAILED,
                () => handleClickRetry(packageId, bodyRegionIdsFromUrl, assessmentNameFromUrl, orderId),
                () => handleClosePaymentStatusPopup()
            );
        }
    }

    const handleClickRetry = async (packageId, bodyRegionIds, assessmentName, orderId) => {
        setConfirmBtnLoading(true);
        await handlePay(packageId, bodyRegionIds, assessmentName, orderId);
    }

    const handleClosePaymentStatusPopup = () => {
        hidePaymentStatusPopup();
        if (isAthleteEnabled) {
            history.push(`${routes.myAssessments}/false`, { refresh: true });
        } else {
            history.push(routes.dashboard);
        }
        // redirectTo(routes.dashboard);
    }

    const handlePay = async (packageId, bodyRegionIds, assessmentName, orderId = '') => {
        if (!packageId || !bodyRegionIds || !assessmentName) {
            toast.error("Invalid url, failed to place order");
            return;
        }

        const frontendUrl = `${window.location.origin}${routes.plans}?` +
            `${CONSTANT.QUERY_PARAM.PACKAGE_ID}=${encodeURIComponent(packageId)}&` +
            `${CONSTANT.QUERY_PARAM.BODY_REGION_IDS}=${encodeURIComponent(bodyRegionIds)}&` +
            `${CONSTANT.QUERY_PARAM.ASSESSMENT_NAME}=${encodeURIComponent(assessmentName)}`;

        const payload = {
            email: (GLOBAL.USER_INFO && GLOBAL.USER_INFO["EmailAddress"]) || "",
            billingEmail: (GLOBAL.USER_INFO && GLOBAL.USER_INFO["EmailAddress"]) || "",
            billingName: patientFullName,
            packageId: packageId,
            orderId: orderId,
            billingCountry: "",
            billingState: "",
            billingPostCode: "",
            billingStreetAddress: "",
            frontendUrl: frontendUrl
        }

        const response = await Payment.createCheckoutSession(payload);
        if (response.success) {
            if (response.data && response.data) {
                window.location.href = response.data;
            }
        } else {
            showPaymentStatusPopup(
                PAYMENT_STATUS_POPUP.FAILED,
                () => handlePay(packageId, bodyRegionIds, assessmentName, orderId),
                () => hidePaymentStatusPopup()
            );
        }
    }

    const handleOnClickStartLater = async (orderId) => {
        setCancelBtnLoading(true);

        if (!orderId) {
            toast.error("Order Id not found");
            return;
        }

        // await DirectToConsumerService.invitationRequest({ OrderId : orderId });
        setCancelBtnLoading(false);
        handleClosePaymentStatusPopup();
    }

    const handleOnClickStartNow = async (orderId, bodyRegionList) => {
        setConfirmBtnLoading(true);

        if (!orderId) {
            toast.error("Order Id not found");
            return;
        }

        let response = await DirectToConsumerService.purchasePackage();
        if (response.success) {
            const purchasedPackage = response?.data?.find((pkg) => pkg?.OrderGId?.toLowerCase() === orderId.toLowerCase());

            if (purchasedPackage?.IsFollowUp) {
                const invitationData = response?.data;
                // Store the invitation response and show the assessment purchase modal
                setInvitationRequestResponse({
                    ...invitationData,
                    BodyRegionIds: bodyRegionList.join(','),
                    OrderId: orderId
                });
                hidePaymentStatusPopup();
                if (isAthleteEnabled) {
                    history.push(`${routes.myAssessments}/false`, { refresh: true });
                } else {
                    history.push(routes.dashboard);
                }
                setShowAssessmentPurchaseModal(true);
            } else {
                let response = await DirectToConsumerService.invitationRequest({ OrderId: orderId });
                if (response.success) {
                    const invitationData = response?.data;
                    startChatBot(
                        {
                            InvitationId: invitationData?.InvitationId,
                            BodyRegionList: bodyRegionList,
                            InvitationTypeName: getRedirectType(invitationData?.InvitationTypeId),
                        },
                        GLOBAL?.USER_INFO?.ContactId || '', //patientId
                        invitationData?.MeetingEndDate || '', //meetingStart
                        invitationData?.MeetingStartDate || '', //meetingEnd
                        () => {
                            // Emit event to reload my-assessments table if on my-assessments page
                            if (location.pathname.includes(routes.myAssessments)) {
                                const refreshEvent = new CustomEvent('refreshMyAssessmentsTable');
                                window.dispatchEvent(refreshEvent);
                            } else {
                                if (isAthleteEnabled) {
                                    window.location = `${routes.myAssessments}/false`;
                                } else {
                                    window.location = routes.dashboard;
                                }
                            }

                            // Callback after chatbot starts
                            setShowAssessmentPurchaseModal(false);
                            hidePaymentStatusPopup();
                        }
                    )
                } else {
                    toast.error("Failed to start assessment, please try again later");
                }
            }
        } else {
            toast.error("Failed to start assessment, please try again later");
        }
        setConfirmBtnLoading(false);
    }

    const onContinueWithWeb = () => {
        setShowMobileAppSuggestion(false);
        if (pendingAction) {
            pendingAction();
            setPendingAction(null);
        }
    };

    const onCancelMobileAppSuggestion = () => {
        setShowMobileAppSuggestion(false);
        setPendingAction(null);
    };

    return {
        handlePay,
        handleOrderPlace,
        showAssessmentPurchaseModal,
        toggleAssessmentPurchaseModal,
        onConfirmNewAssessment,
        onCancelFollowUpAssessment,
        showMobileAppSuggestion,
        onContinueWithWeb,
        onCancelMobileAppSuggestion
    };
}

export default useHandlePayment;
